import { Select } from "antd";
import React, { useState } from "react";

export default function SelectOnce(props){
    const [hasBeenSelected, setHasBeenSelected] = useState(false);
    return <Select {...props} disabled={hasBeenSelected} onChange={(e) => {setHasBeenSelected(true); props.onChange && props.onChange(e)}}>
    </Select>
}